/**
 * A super module that collects available sub-modules.
 * 
 * @namespace vef.events
 * @memberof vef
 */

export * from './EventManager.js';
export * from './EventObject.js';